const _translations = {
	'Je souhaite offrir cet abonnement': 'Je souhaite offrir cet abonnement',
};

export const __ = string_id => _translations[string_id] || string_id;